// extracted by mini-css-extract-plugin
export var statItem = "_hx-1";
export var statsRow = "_hx-0";